/* Theme preview only: no backend inventory or checkout enforcement. */
(() => {
  'use strict';
  const variants = new Map(), parsed = new WeakSet(), ownDisabled = new WeakSet();
  let scheduled = false;
  function ingest() {
    document.querySelectorAll('script[data-mm-stock-map],script[data-mm-stock-product],script[data-section-data],script[data-swatch-data]').forEach(script => {
      if (parsed.has(script)) return;
      try {
        const data = JSON.parse(script.textContent), product = data.product || data;
        (product.variants || []).forEach(v => { if (typeof v.mm_stock_quantity === 'number') variants.set(String(v.id), v); });
        parsed.add(script);
      } catch (_) {}
    });
  }
  function variantId(form) { const input = form && form.querySelector('[name="id"]'); return input ? String(input.value) : ''; }
  function quantity(form) { const input = form && form.querySelector('[name="quantity"]'); const n = Number(input ? input.value : 1); return Number.isFinite(n) && n > 0 ? n : 1; }
  function allowed(id, count = 1) { const v = variants.get(String(id)); return !!v && v.available === true && v.mm_stock_quantity > 0 && count <= v.mm_stock_quantity && count >= (v.mm_stock_minimum || 1); }
  function setDisabled(button, blocked) {
    if (blocked) {
      if (!button.disabled) { button.disabled = true; ownDisabled.add(button); }
      if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
    } else if (ownDisabled.has(button)) { button.disabled = false; button.removeAttribute('aria-disabled'); ownDisabled.delete(button); }
  }
  function syncForm(form) {
    const id = variantId(form); if (!id || !variants.has(id)) return;
    const v = variants.get(id), noStock = v.available !== true || v.mm_stock_quantity <= 0, blocked = !allowed(id, quantity(form));
    form.querySelectorAll('[data-product-atc],.add-to-cart-button,.sold-out-button,button[type="submit"],input[type="submit"]').forEach(button => {
      setDisabled(button, blocked);
      const label = button.querySelector('.atc-button--text');
      if (label && noStock && label.textContent.trim() !== 'Sold out') label.textContent = 'Sold out';
      else if (label && !noStock && label.textContent.trim() === 'Sold out') label.textContent = 'Add to cart';
    });
    form.querySelectorAll('.shopify-payment-button,shopify-accelerated-checkout').forEach(el => {
      if (el.hidden !== blocked) el.hidden = blocked;
      if (blocked) el.setAttribute('data-mm-stock-hidden', 'true'); else el.removeAttribute('data-mm-stock-hidden');
    });
  }
  function syncCart(cart) {
    const list = cart.querySelector('[data-cart-item-list][data-mm-cart-list-blocked]');
    if (!list) return;
    // Only the server-rendered list can clear a stock block. Empire morphs this
    // list after a successful cart change, leaving the outer form untouched.
    const hasItems = !!list.querySelector('[data-cartitem]');
    const blocked = list.dataset.mmCartListBlocked !== 'false' || !hasItems;
    const state = String(blocked);
    if (cart.dataset.mmCartBlocked !== state) cart.dataset.mmCartBlocked = state;
    cart.querySelectorAll('button[name="checkout"],input[name="checkout"]').forEach(button => {
      if (blocked) {
        if (!button.disabled) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.dataset.mmStockCheckoutDisabled = 'true';
        }
      } else if (button.dataset.mmStockCheckoutDisabled === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.mmStockCheckoutDisabled;
      }
    });
    cart.querySelectorAll('[data-mm-cart-stock-message]').forEach(el => {
      const showMessage = blocked && hasItems;
      if (el.hidden === showMessage) el.hidden = !showMessage;
    });
    cart.querySelectorAll('[data-mm-stock-additional-checkout]').forEach(el => {
      if (blocked) {
        if (!el.hidden) { el.hidden = true; el.dataset.mmStockHidden = 'true'; }
      } else if (el.dataset.mmStockHidden === 'true') {
        el.hidden = false;
        delete el.dataset.mmStockHidden;
      }
    });
  }
  function sync() {
    scheduled = false; ingest();
    document.querySelectorAll('form[action*="/cart/add"],form[data-mm-stock-form]').forEach(syncForm);
    document.querySelectorAll('[data-quick-buy][data-variant-id]').forEach(button => { if (variants.has(button.dataset.variantId)) setDisabled(button, !allowed(button.dataset.variantId)); });
    document.querySelectorAll('form[data-mm-cart-blocked]').forEach(syncCart);
    document.querySelectorAll('[data-mm-cart-blocked="true"]').forEach(cart => {
      cart.querySelectorAll('[name="checkout"],a[href*="/checkout"]').forEach(button => setDisabled(button, true));
      cart.querySelectorAll('.additional-checkout-buttons').forEach(el => { if (!el.hidden) el.hidden = true; });
    });
  }
  function schedule() { if (!scheduled) { scheduled = true; queueMicrotask(sync); } }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  document.addEventListener('submit', event => {
    const form = event.target; if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-mm-cart-blocked="true"]') && event.submitter && event.submitter.name === 'checkout') return stop(event);
    if (!form.matches('form[action*="/cart/add"],form[data-mm-stock-form]')) return;
    ingest(); if (!allowed(variantId(form), quantity(form))) { stop(event); syncForm(form); }
  }, true);
  document.addEventListener('click', event => {
    const target = event.target.closest && event.target.closest('[data-quick-buy],[data-product-atc],.shopify-payment-button,shopify-accelerated-checkout,[name="checkout"],a[href*="/checkout"]');
    if (!target) return;
    if (target.closest('[data-mm-cart-blocked="true"]') && (target.name === 'checkout' || /checkout/.test(target.getAttribute('href') || ''))) return stop(event);
    const form = target.closest('form'), id = target.dataset.variantId || variantId(form);
    ingest(); if (id && !allowed(id, quantity(form))) { stop(event); schedule(); }
  }, true);
  document.addEventListener('product-form:cart:request', event => {
    ingest(); const data = event.detail && event.detail.form;
    if (!data || typeof data.get !== 'function') return;
    if (!allowed(data.get('id'), Number(data.get('quantity') || 1))) { stop(event); if (typeof event.detail.reject === 'function') event.detail.reject(new Error('Sold out')); }
  }, true);
  document.addEventListener('change', schedule, true); document.addEventListener('input', schedule, true);
  ['variant:change','variant-change','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
  function start() { sync(); new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value','data-variant-id','data-mm-cart-list-blocked']}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
